// frontend/src/askos/SamkalpAskOS.js
//
// Root auth gate for the dedicated Samkalp entry point, mirroring the
// existing AskOS root gate in pages/AskOS.js. Reuses the existing
// askos_token / askos_slug localStorage keys so the rest of AskOS's
// auth plumbing keeps working unmodified.
import React, { useState } from 'react';
import SamkalpLoginPage from './SamkalpLoginPage';
import AskosDashboard from './AskosDashboard';

const ACADEMY_SLUG = 'samkalp-ias';

const SamkalpAskOS = () => {
    const storedToken = localStorage.getItem('askos_token');
    const storedSlug = localStorage.getItem('askos_slug');
    const [authSession, setAuthSession] = useState(
        storedToken && storedSlug === ACADEMY_SLUG ? { slug: ACADEMY_SLUG, access_token: storedToken } : null
    );

    const handleLogout = () => {
        localStorage.removeItem('askos_token');
        localStorage.removeItem('askos_slug');
        setAuthSession(null);
    };

    if (!authSession) return <SamkalpLoginPage onLogin={sess => setAuthSession(sess)} />;
    return <AskosDashboard slug={ACADEMY_SLUG} onLogout={handleLogout} onAuthError={handleLogout} />;
};

export default SamkalpAskOS;
